// Mirrors the backend SecurityResolveResponse feature tree (keyed maps).
export interface IFeatureNode {
    type: string;
    displayName: string;
    route?: string;
    icon?: string;
    dbMapping?: string;
    isSensitive: boolean;
    enabled: boolean;
    accessLevel: number; // 0 hidden, 1 read-only/masked, 2 read-write
    children: Record<string, IFeatureNode>;
}

export interface IFeatureTree {
    role: string;
    country?: string;
    permissions: string[];
    features: Record<string, IFeatureNode>;
}

export const FeatureTreeActionType = {
    REQUEST_FEATURE_TREE: 'featureTree/REQUEST_FEATURE_TREE',
    RECEIVE_FEATURE_TREE: 'featureTree/RECEIVE_FEATURE_TREE',
    ERROR_FEATURE_TREE: 'featureTree/ERROR_FEATURE_TREE',
} as const;

export type FeatureTreeAction =
    | IRequestFeatureTreeAction
    | IReceiveFeatureTreeAction
    | IFeatureTreeErrorAction;

export interface IRequestFeatureTreeAction {
    type: typeof FeatureTreeActionType.REQUEST_FEATURE_TREE;
    payload: { groups: string[] };
}

export interface IReceiveFeatureTreeAction {
    type: typeof FeatureTreeActionType.RECEIVE_FEATURE_TREE;
    tree: IFeatureTree;
}

export interface IFeatureTreeErrorAction {
    type: typeof FeatureTreeActionType.ERROR_FEATURE_TREE;
    errorMessage?: string;
    /** HTTP status of the failed feature-config call, when available. */
    statusCode?: number | null;
    /** True when the failure is a geo-restriction block (403 from the app-wide geo gate). */
    isGeoBlocked?: boolean;
    /** True when the user has no authorized PBT security group (403 from the app-wide role gate). */
    isAccessDenied?: boolean;
}
